import { useEffect, useState } from 'react'
import { Users } from 'react-feather'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Card, CardBody, Col, Row } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { URL_EMPLOYEE_PAYMENTS_SUMMARY } from 'utils/pathUrl'

const FooterConfirmation = ({ variant }) => {
  const navigate = useNavigate()
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const { isOpenNavbar } = useSelector((s) => s.dashboard)
  const { disbursementData } = useSelector(
    (state) => state.employeePaymentsList,
  )

  const totalEmployees = disbursementData?.disburses?.length || 0

  const countAmountFilled =
    disbursementData?.disburses?.filter(
      (e) => e?.amount && e?.amount !== 0,
    )?.length || 0

  const total =
    disbursementData?.disburses?.reduce(
      (acc, item) => acc + (item.amount || 0),
      0,
    ) || 0

  const isTabletOrDesktop = screenWidth >= 768

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  if (variant === 'wage-salary') {
    if (!countAmountFilled || countAmountFilled === 0) {
      return null
    }

    return (
      <>
        <Card
          className="border-0 shadow-lg mt-4"
          style={{
            position: 'fixed',
            bottom: 0,
            backgroundColor: '#FDFBF7',
            width: isTabletOrDesktop
              ? `calc(96% - ${isOpenNavbar ? '253px' : '53px'})`
              : `calc(96% - 15px)`,
            zIndex: 1,
            borderRadius: '16px 16px 0 0',
            boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.15)',
          }}
        >
          <CardBody className="p-4">
            <Row className="align-items-center">
              <Col xs="12" md="4" className="d-flex align-items-center gap-3">
                <div className="bg-light p-2 rounded-circle text-primary">
                  <Users size={24} />
                </div>
                <div
                  className="d-flex flex-column text-muted"
                  style={{ fontSize: '14px' }}
                >
                  <span>{totalEmployees} karyawan</span>
                  <span>{countAmountFilled} dipilih</span>
                </div>
              </Col>

              <Col xs="12" md="4" className="d-flex flex-column mt-3 mt-md-0">
                <span className="text-muted" style={{ fontSize: '14px' }}>
                  Total terpilih
                </span>
                <span className="fw-bold" style={{ fontSize: '20px' }}>
                  Rp{newFormatThousandSeparator(total || 0, 0)}
                </span>
              </Col>

              <Col
                xs="12"
                md="4"
                className="d-flex justify-content-md-end mt-3 mt-md-0"
              >
                <Button
                  color="primary"
                  className="px-4 py-2 fw-bold"
                  style={{
                    borderRadius: '8px',
                    backgroundColor: '#02678D',
                    borderColor: '#02678D',
                  }}
                  data-testid="emp-pay-confirm-footer-button"
                  onClick={() => {
                    navigate(URL_EMPLOYEE_PAYMENTS_SUMMARY)
                  }}
                >
                  Lanjut Pembayaran
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <div style={{ height: '90px' }}></div>
      </>
    )
  }

  return (
    <>
      <Card
        className="border-0 shadow-lg mt-4"
        style={{
          position: 'fixed',
          bottom: 0,
          width: isTabletOrDesktop
            ? `calc(96% - ${isOpenNavbar ? '253px' : '53px'})`
            : `calc(96% - 15px)`,
          zIndex: 1,
          borderRadius: '16px 16px 0 0',
          boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        <CardBody>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <span className="text-muted">
                {countAmountFilled} employee(s) selected
              </span>
              <div className="">
                Total:{' '}
                <span className="fw-bold text-primary">
                  Rp{newFormatThousandSeparator(total, 0)}
                </span>
              </div>
            </div>
            <div>
              <Button
                color="primary"
                size="sm"
                data-testid="emp-pay-confirm-footer-button"
                onClick={() => {
                  navigate(URL_EMPLOYEE_PAYMENTS_SUMMARY)
                }}
              >
                Proceed to Confirmation
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>
      <div style={{ height: '80px' }}></div>
    </>
  )
}

export default FooterConfirmation
